import { paths } from './paths';

/** Soft-colour theme for a nav item's icon chip (and its count badge, if any). */
export type NavTone = 'brand' | 'neutral' | 'success' | 'warning' | 'info';

/** Which live count (if any) to surface as a badge on this item. */
export type NavBadgeKey = 'qcQueue' | 'exceptions';

export interface NavItem {
  label: string;
  to: string;
  /** Key into the Sidebar's icon map. */
  iconKey: string;
  tone: NavTone;
  badgeKey?: NavBadgeKey;
}

/** Primary left-sidebar navigation for the dashboard. */
export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', to: paths.dashboard, iconKey: 'dashboard', tone: 'brand' },
  { label: 'Returns', to: paths.returns, iconKey: 'returns', tone: 'brand' },
  { label: 'Exchanges', to: paths.exchanges, iconKey: 'exchanges', tone: 'neutral' },
  { label: 'Refunds', to: paths.refunds, iconKey: 'refunds', tone: 'success' },
  { label: 'QC Queue', to: paths.qc, iconKey: 'qc', tone: 'success', badgeKey: 'qcQueue' },
  { label: 'Exceptions', to: paths.exceptions, iconKey: 'exceptions', tone: 'warning', badgeKey: 'exceptions' },
  { label: 'Analytics', to: paths.analytics, iconKey: 'analytics', tone: 'info' },
  { label: 'Blocklist', to: paths.blocklist, iconKey: 'blocklist', tone: 'brand' },
  { label: 'Autopilot', to: paths.autopilot, iconKey: 'autopilot', tone: 'brand' },
  { label: 'Settings', to: paths.settings, iconKey: 'settings', tone: 'neutral' },
];
